// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"efbbe698","455":"4e8a5d36","977":"c49f0909"}[chunkId] + ".chunk.js";
};